export class SnackbarOptions {
  constructor({
    message = '',
    color = '',
    timeout = 3000,
    icon = '',
    show = false
  } = {}) {
    this.message = message
    this.color = color
    this.timeout = timeout
    this.icon = icon
    this.show = show
  }

  static getOptions(opts) {
    return {
      show: true,
      message: opts.message,
      color: opts.color,
      timeout: opts.timeout,
      icon: opts.icon
    }
  }

  static notifySuccess({
    message = 'Success',
    color = 'success',
    timeout = 3000,
    icon = 'done'
  } = {}) {
    return SnackbarOptions.getOptions({ message, color, timeout, icon })
  }

  static notifyError({
    message = 'Error',
    color = 'error',
    timeout = -1,
    icon = 'close'
  } = {}) {
    return SnackbarOptions.getOptions({ message, color, timeout, icon })
  }

  static notifyWarning({
    message = 'Warning',
    color = 'warning',
    timeout = 3000,
    icon = 'report'
  } = {}) {
    return SnackbarOptions.getOptions({ message, color, timeout, icon })
  }

  static notify({ message = '', color = '', timeout = 3000, icon = '' } = {}) {
    return SnackbarOptions.getOptions({ message, color, timeout, icon })
  }
}
